import * as UI from "@iyk/ui"
import type * as React from "react"

export function PlayPauseButton({ isPlaying, ...props }: Props) {
  return (
    <button
      {...props}
      className={UI.cx([
        "bg-gray-12 rounded-full size-11 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed",
        props.className,
      ])}
    >
      {isPlaying ? (
        <UI.Icon.Pause className="size-5 text-gray-1" />
      ) : (
        <UI.Icon.Play className="size-6 text-gray-1" />
      )}
    </button>
  )
}

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isPlaying: boolean
}
